var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(this.item)
    ? _c(
        "div",
        { staticClass: "categ_info" },
        [
          _c("info_field", {
            attrs: {
              f_uniq: "ct",
              f_type: "title",
              is_disabled: false,
              f_title: _vm.__t("NAME"),
              f_val: _vm.cur_item.title,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "organization" } },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.__t("GROUP_ID")) + "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.groups.length > 0
              ? _c(
                  "div",
                  {},
                  [
                    _c(
                      "v-select",
                      {
                        staticClass: "imc_reasons",
                        attrs: {
                          label: "title",
                          options: this.groups,
                          reduce: function (item) {
                            return item.id
                          },
                          filterable: false,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "option",
                              fn: function (option) {
                                return [
                                  _c("div", { staticClass: "d-center" }, [
                                    _c("div", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(option.title) +
                                          "\n                            "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "small badge border border-info text-info mr-1",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(option.group_type) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          323893712
                        ),
                        model: {
                          value: _vm.cur_item.group_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.cur_item, "group_id", $$v)
                          },
                          expression: "cur_item.group_id",
                        },
                      },
                      [
                        _c("template", { slot: "no-options" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.__t("CHOICE_ORG")) +
                              "\n                "
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "ct_al",
              f_type: "alias",
              f_title: _vm.__t("ALIAS"),
              f_val: _vm.cur_item.alias,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "intro_html" } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__t("INTRO_ARTICLE_HTML")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-group flex-nowrap d-block" },
              [
                _c("vue-editor", {
                  attrs: { "editor-toolbar": _vm.editor_rules },
                  model: {
                    value: _vm.item.description,
                    callback: function ($$v) {
                      _vm.$set(_vm.item, "description", $$v)
                    },
                    expression: "item.description",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }